import App from './App.svelte';
// get elements
const elements = document.getElementsByTagName("pixobe-coloring-book");
const targets = Array.from(elements);
var apps = [];
if (targets) {
    apps = targets.map(target => new App({
        target, props: {
            src: target.getAttribute("src")
        }
    }));
}
export default apps;
